import React, { useEffect, useState } from "react";
import Header from "../../../layout/header";
import ReactPaginate from "react-paginate";
import Loader from "../../../../Loader/Loader";
import NotFoundData from "../../../../Images/no-data-found.webp";
import DashboardMenu from "../../../layout/dashboardMenu";
import Moment from "moment";
import { Modal, Button } from "react-bootstrap";
import FailedModal from "../../../CustomModal/Failed";
import SuccessModal from "../../../CustomModal/Success";
import { toast } from "react-toastify";

const ApprovalPendingList = ({
  approvalPending,
  approvalPendingList = [],
  match,
  history,
  approvalActivity,
  approved = [],
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [userId, setUserId] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState("");
  const [inputList, setInputList] = useState([
    {
      remark: "",
      id: "",
      approval_status: "",
    },
  ]);

  const [isHovered, setIsHovered] = useState(false);
  const [id, setId] =useState('')
  const handleMouseEnter = () => setIsHovered(true);
  const handleMouseLeave = () => setIsHovered(false);


//   const [isFailedModalOpen, setIsFailedModalOpen] = useState(false);
//   const [isSuccessModalOpen, setIsSuccessModalOpen] = React.useState(false);
//   const [countToOpenModal, setCountToOpenModal] = useState(0);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await approvalPending(1);
      setIsLoading(false);
    })();
    setUserId(window.localStorage.user_id);
  }, []);

  const onPageChange = async (val) => {
    setIsLoading(true);
    await approvalPending(val?.selected + 1);
    setIsLoading(false);
  };

  const handleInput = (key, val, e) => {
    e.preventDefault();
    let list = [...inputList];
    list[0][key] = val;
    setInputList(list);
  };

  const handleShow = (type) => {
    setModalType(type);
    setShowModal(true);
  };

  function diff_hours(dt2, dt1) {
    const diffTime = dt2.getTime() - dt1.getTime();
    const diffDays = Math.floor(diffTime / (1000 * 3600 * 24));
    const min = Math.floor(diffTime / 1000 / 60);
    return min + " Mins";
  }

  const handleClose = () => setShowModal(false);

  const handleSubmit = async (e, status, modalType) => {
    if(inputList[0]['remark'] === '') {
      toast.error("Remark is required!");
      // setTimeout(() => {
      //   window.location.reload();
      // }, 2000);
      return false;
    }
    setModalType(modalType);
    setShowModal(true);
    e.preventDefault();
  
    let list = [...inputList];
    list[0]["approval_status"] = status;
    list[0]["id"] = id;

    setIsLoading(true);
    const res = await approvalActivity(list[0]);
    // if (res) {
    //   if (status === 2) {
    //     toast.success("Activity approved successfully");
    //   } else {
    //     toast.success("Activity rejected successfully");
    //   }
    // } else {
    //   if (status === 2) {
    //     toast.error("Failed to approve activity");
    //   } else {
    //     toast.error("Failed to reject activity");
    //   }
    // }
  
    setIsLoading(false);

    // setTimeout(() => {
    //   window.location.reload();
    // }, 2000);
  };



  useEffect(() => {
    if (approved?.status === 200) {
      toast.success(approved?.message);
      window.location.href='approved-pending-list'
    } else if (parseInt(approved?.status)!== 200) {
      toast.error(approved?.message);
    }
  }, [approved]);

  return (
    <>
      {/* <SuccessModal
        isOpen={isSuccessModalOpen}
        msg={approved?.message}
        url={"approved-pending-list"}
      />

      <FailedModal
        isOpen={isFailedModalOpen}
        msg={approved?.message}
        countToOpenModal={countToOpenModal}
      /> */}
      <Loader isLoading={isLoading} />
      {/*<Sidebar/>*/}
      {/* section start  */}
      <div id="wrapper">
        <DashboardMenu />
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Header title={"Activity List"} history={history} />
            <div className="container-fluid">
              {/*Heading*/}
              <div className="container-fluid bootstrap snippets bg-white">
                <div className="d-sm-flex align-items-center justify-content-between mb-2 bg-white">
                  <div className="row b-13"></div>
                </div>
                <div className="row mt-10">
                  <>
                    {approvalPendingList &&
                      approvalPendingList?.data !== undefined &&
                      approvalPendingList?.data.length > 0 &&
                      approvalPendingList?.data.map((val, i) => {
                        return (
                          <>
                            <div className="col-md-4 col-sm-6">
                              <div className="card-big-shadow card-padding">
                                <div
                                  className="card card-just-text"
                                  data-background="color"
                                  data-color=""
                                  data-radius="none"
                                >
                                  <div className="content">
                                    <h6 className="category">
                                      {parseInt(val?.status) === 1 ? (
                                        <div
                                          className="header-ui-item-opp"
                                          style={{ backgroundColor: "#bea925" }}
                                        >
                                          Pending
                                        </div>
                                      ) : parseInt(val?.status) === 2 ? (
                                        <div className="header-ui-item-opp">
                                          Completed
                                        </div>
                                      ) : parseInt(val?.status) === 3 ? (
                                        <div
                                          className="header-ui-item-opp"
                                          style={{ backgroundColor: "#88130a" }}
                                        >
                                          Cancelled
                                        </div>
                                      ) : parseInt(val?.status) === 4 ? (
                                        <div
                                          className="header-ui-item-opp"
                                          style={{ backgroundColor: "#88130a" }}
                                        >
                                          Rejected
                                        </div>
                                      ) : (
                                        <div
                                          className="header-ui-item-opp"
                                          style={{ backgroundColor: "#1894cb" }}
                                        >
                                          Rejected & Rescheduled
                                        </div>
                                      )}
                                      <div className="row">
                                        <div
                                          className="col-10"
                                          style={{
                                            color: "#000",
                                            fontSize: "20px",
                                            textAlign: "left",
                                            paddingLeft: "20px",
                                          }}
                                        >
                                          <span className="">{val?.name}</span>
                                        </div>
                                        {/* <div className="col-2"> */}
                                          {/*TOGGLE*/}
                                          {/* <div
                                            className="dropdown"
                                            style={{ float: "right" }}
                                          >
                                            <i
                                              className="bi bi-three-dots-vertical"
                                              data-toggle="dropdown"
                                              style={{ color: "black" }}
                                            ></i>
                                            <ul className="dropdown-menu">
                                              <li>
                                                <a
                                                  href={`activity-approval/${val?.id}`}
                                                  className="btn btn-sm"
                                                  type="button"
                                                >
                                                  Action
                                                </a>
                                              </li>
                                            </ul>
                                          </div> */}
                                          {/*TOGGLE END*/}
                                        {/* </div> */}
                                      </div>
                                      <div className="row list-view">
                                        <div className="mb-flex">
                                          <div className="col-md-6 col-sm-6 no-wrap">
                                            <i className="fas fa-comment"></i>
                                            &nbsp;&nbsp;Toll
                                          </div>
                                          <div className="col-md-6 col-sm-6">
                                            <span
                                              className="trigger"
                                              data-tooltip-id="1"
                                              title={val?.client_name}
                                            >
                                              {val?.client_name}
                                            </span>
                                          </div>
                                        </div>
                                        {val?.cReason !== undefined && (
                                          <div className="mb-flex">
                                            <div className="col-md-6 col-sm-6 no-wrap">
                                              <i className="fas fa-comment"></i>
                                              &nbsp;&nbsp;Reason
                                            </div>
                                            <div className="col-md-6 col-sm-6">
                                              <span
                                                className="trigger"
                                                data-tooltip-id="1"
                                                title={val?.cReason}
                                              >
                                                {val?.cReason}
                                              </span>
                                            </div>
                                          </div>
                                        )}
                                        <div className="mb-flex">
                                          <div className="col-md-6 col-sm-6 no-wrap">
                                            <i className="bi bi-building"></i>
                                            &nbsp;&nbsp;Activity Date
                                          </div>
                                          <div className="col-md-6 col-sm-6">
                                            {Moment(val?.activity_date).format(
                                              "DD-MM-YYYY HH:mm:ss"
                                            )}
                                          </div>
                                        </div>
                                        <div className="mb-flex">
                                          <div className="col-md-6 col-sm-6 no-wrap">
                                            <i className="bi bi-person-check-fill"></i>
                                            &nbsp;&nbsp;Created By
                                          </div>
                                          <div className="col-md-6 col-sm-6">
                                            {val?.user_name}
                                          </div>
                                        </div>
                                        <div className="mb-flex">
                                          <div className="col-md-6 col-sm-6 no-wrap">
                                            <i className="bi bi-person-check-fill"></i>
                                            &nbsp;&nbsp;Assigned To
                                          </div>
                                          <div className="col-md-6 col-sm-6">
                                            {val?.assign_to}
                                          </div>
                                        </div>

                                        {val?.meta_data?.remark !== undefined &&
                                          val?.meta_data?.remark !== "" && (
                                            <div className="mb-flex">
                                              <div className="col-md-6 col-sm-6 no-wrap">
                                                <i className="bi bi-person-check-fill"></i>
                                                &nbsp;&nbsp;Remarks
                                              </div>
                                              <div className="col-md-6 col-sm-6">
                                                <span
                                                  className="trigger"
                                                  data-tooltip-id="1"
                                                  title={val?.meta_data?.remark}
                                                >
                                                  {val?.meta_data?.remark}
                                                </span>
                                              </div>
                                            </div>
                                          )}
                                        {val?.dropped_reason !== "" &&
                                          val?.dropped_reason !== null && (
                                            <>
                                              <div className="mb-flex">
                                                <div className="col-md-6 col-sm-6 no-wrap">
                                                  <i
                                                    className="fa fa-ban"
                                                    aria-hidden="true"
                                                  ></i>
                                                  &nbsp;&nbsp;Dropped
                                                </div>
                                                <div className="col-md-6 col-sm-6">
                                                  {val?.dropped_reason}
                                                </div>
                                              </div>
                                              <div className="mb-flex">
                                                <div className="col-md-6 col-sm-6 no-wrap">
                                                  <i className="fas fa-calendar-alt"></i>
                                                  &nbsp;&nbsp;Dropped Date
                                                </div>
                                                <div className="col-md-6 col-sm-6">
                                                  {Moment(
                                                    val?.updated_at
                                                  ).format("DD-MM-YYYY")}
                                                </div>
                                              </div>
                                            </>
                                          )}
                                        <div className="mb-flex">
                                          <div className="col-md-6 col-sm-6 no-wrap">
                                            <i className="fas fa-calendar-alt"></i>
                                            &nbsp;&nbsp;Created Date
                                          </div>
                                          <div className="col-md-6 col-sm-6">
                                            {Moment(val?.created_at).format(
                                              "DD-MM-YYYY"
                                            )}
                                          </div>
                                        </div>
                                        {val?.purpose !== undefined &&
                                          val?.purpose != null &&
                                          val?.purpose !== "" && (
                                            <div className="mb-flex">
                                              <div className="col-md-6 col-sm-6 no-wrap">
                                                <i className="fas fa-bus-alt"></i>
                                                &nbsp;&nbsp;Purpose of visit
                                              </div>
                                              <div className="col-md-6 col-sm-6">
                                                <span
                                                  className="trigger"
                                                  data-tooltip-id="2"
                                                  title={val?.purpose}
                                                >
                                                  {val?.purpose}
                                                </span>
                                              </div>
                                            </div>
                                          )}
                                        {val?.cStage !== undefined &&
                                          val?.cStage != null &&
                                          val?.cStage !== "" && (
                                            <div className="mb-flex">
                                              <div className="col-md-6 col-sm-6 no-wrap">
                                                <i className="fas fa-door-closed"></i>
                                                &nbsp;&nbsp;Client Stage
                                              </div>
                                              <div className="col-md-6 col-sm-6">
                                                <span
                                                  className="trigger"
                                                  data-tooltip-id="3"
                                                  title={val?.cStage}
                                                >
                                                  {val?.cStage}
                                                </span>
                                              </div>
                                            </div>
                                          )}
                                        {parseInt(val?.status) === 2 &&
                                          val?.attendance_create !==
                                            undefined &&
                                          val?.attendance_update != null &&
                                          val?.cStage !== "" && (
                                            <div className="mb-flex">
                                              <div className="col-md-6 col-sm-6 no-wrap">
                                                <i className="fas fa-clock"></i>
                                                &nbsp;&nbsp;Duration
                                              </div>
                                              <div className="col-md-6 col-sm-6">
                                                {diff_hours(
                                                  new Date(
                                                    val?.attendance_update
                                                  ),
                                                  new Date(
                                                    val?.attendance_create
                                                  )
                                                )}
                                              </div>
                                            </div>
                                          )}
                                        {val?.description !== undefined &&
                                          val?.description !== "" && (
                                            <div className="mb-flex">
                                              <div className="col-md-6 col-sm-6 no-wrap">
                                                <i className="bi bi-card-text"></i>
                                                &nbsp;&nbsp;Description
                                              </div>
                                              <div className="col-md-6 col-sm-6">
                                                <span
                                                  className="trigger"
                                                  data-tooltip-id="1"
                                                  title={val?.description}
                                                >
                                                  {val?.description}
                                                </span>
                                              </div>
                                            </div>
                                          )}
                                      </div>
                                      <hr />
                                      <div className="col-md-12 d-flex">
                                        <div className="col-md-6">
                                          <div
                                            className="btn btn-danger btn-sm"                                            aria-hidden="true"
                                            onClick={() => {handleShow("cross")
                                              setId(val?.id)}}
                                          >Reject</div>
                                        </div>
                                        <div className="col-md-6">
                                            <div
                                            className="btn btn-success btn-sm"
                                            aria-hidden="true"
                                            onClick={() => {
                                              handleShow("tick")
                                              setId(val?.id)
                                            }}
                                            >Approve</div>
                                        </div>
                                      </div>
                                      {/* Modal */}
                                      <Modal
                                        show={showModal}
                                        onHide={handleClose}
                                        centered 
                                        >
                                        <Modal.Header closeButton>
                                            <Modal.Title>
                                            {modalType === "tick" ? "Approve Activity" : "Reject Activity"}
                                            </Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body>
                                            <div className="col-md-12">
                                            <textarea
                                                className="form-control form-control-user"
                                                placeholder="Remarks"
                                                onChange={(e) => {
                                                handleInput("remark", e.target.value, e);
                                                }}
                                                id="validationCustom01"
                                                rows="4"
                                                cols="50"
                                                required={true}
                                            />
                                            </div>
                                        </Modal.Body>
                                        <Modal.Footer>
                                            <Button
                                            className="btn btn-danger"
                                            variant="secondary"
                                            onClick={handleClose}
                                            >
                                            Close
                                            </Button>
                                            <Button
                                            className="btn btn-primary"
                                            style={{
                                              backgroundColor: isHovered ? '#6a886a' : 'green',
                                            }}
                                            onMouseEnter={handleMouseEnter}
                                            onMouseLeave={handleMouseLeave}                                      
                                            variant="secondary"
                                            onClick={(e) => {
                                                if (modalType === "tick") {
                                                handleSubmit(e, 2, "tick");
                                                } else {
                                                handleSubmit(e, 3, "cross");
                                                }
                                            }}
                                            >
                                            Submit
                                            </Button>
                                        </Modal.Footer>
                                        </Modal>

                                    </h6>
                                    {/* <div className="col-sm-6">
                                      <a
                                        href={`/fast-tag-toll-activity/${match?.params?.account_id}`}
                                        className="draft-float"
                                      >
                                        <p
                                          className="my-float"
                                          style={{ marginTop: "20px" }}
                                        >
                                          <i
                                            className="fa fa-plus"
                                            aria-hidden="true"
                                          ></i>
                                        </p>
                                      </a>
                                    </div> */}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </>
                        );
                      })}
                    {approvalPendingList &&
                      approvalPendingList?.data !== undefined &&
                      approvalPendingList?.data.length > 0 && (
                        <div className="panel-pagination-col panel-table-pagination">
                          <ReactPaginate
                            previousLabel={"<"}
                            nextLabel={">"}
                            breakLabel={"..."}
                            breakClassName={"break-me"}
                            pageCount={
                              approvalPendingList?.total /
                              approvalPendingList?.per_page
                            }
                            forcePage={approvalPendingList?.current_page - 1}
                            pageRangeDisplayed={4}
                            onPageChange={onPageChange}
                            activeClassName={"active"}
                          />
                        </div>
                      )}
                    {approvalPendingList &&
                      approvalPendingList?.data !== undefined &&
                      approvalPendingList?.data.length === 0 && (
                        <>
                          <img
                            src={NotFoundData}
                            className="not-found-data"
                            alt={""}
                          />
                          <div
                            className="text-center"
                            style={{ width: "100%" }}
                          >
                            Data Not Found
                          </div>
                        </>
                      )}
                  </>
                  {/*PAGINATION END*/}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* section ends */}
    </>
  );
};

export default ApprovalPendingList;
